/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeUsers.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   User Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:37 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const USER_LIST_CONTAINER_LOADED = 'USER_LIST_CONTAINER_LOADED';
export const USER_LIST_CONTAINER_UNLOADED = 'USER_LIST_CONTAINER_UNLOADED';
export const USER_LIST_TABLE_LOADED = 'USER_LIST_TABLE_LOADED';
export const USER_LIST_TABLE_UNLOADED = 'USER_LIST_TABLE_UNLOADED';
export const USER_LIST_CHANGE_STATUS = 'USER_LIST_CHANGE_STATUS';
export const USER_SELECT_ROW = 'USER_SELECT_ROW';
export const USER_ADD = 'USER_ADD';
export const USER_EDIT = 'USER_EDIT';
export const USER_DELETE = 'USER_DELETE';
export const USER_OPEN_WARNING = 'USER_OPEN_WARNING';
export const USER_CLOSE_WARNING = 'USER_CLOSE_WARNING';

export const USER_EDIT_CONTAINER_LOADED = 'USER_EDIT_CONTAINER_LOADED';
export const USER_EDIT_CONTAINER_UNLOADED = 'USER_EDIT_CONTAINER_UNLOADED';
export const USER_EDIT_FORM_LOADED = 'USER_EDIT_FORM_LOADED';
export const USER_EDIT_FORM_UNLOADED = 'USER_EDIT_FORM_UNLOADED';
export const USER_OPEN_GENERATE_PASSWORD = 'USER_OPEN_GENERATE_PASSWORD';
export const USER_CLOSE_GENERATE_PASSWORD = 'USER_CLOSE_GENERATE_PASSWORD';
export const USER_OPEN_GENERATE_PASSWORD_RESULTS = 'USER_OPEN_GENERATE_PASSWORD_RESULTS';
export const USER_CLOSE_GENERATE_PASSWORD_RESULTS = 'USER_CLOSE_GENERATE_PASSWORD_RESULTS';
export const USER_EDIT_DATA_LOAD = 'USER_EDIT_DATA_LOAD';

export const USER_DRAW_ROLE_SWITCHES = 'USER_DRAW_ROLE_SWITCHES';
export const USER_UPDATE_CHECK = 'USER_UPDATE_CHECK';

export const USER_UPDATE_FIELD = 'USER_UPDATE_FIELD';
export const USER_EDIT_CONTAINER_SUBMIT = 'USER_EDIT_CONTAINER_SUBMIT';
export const USER_EDIT_CONTAINER_CANCEL = 'USER_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeUsers.js